export const SYSTEM_FOLDER_REDACT_TRASH = 'REDACT TRASH';

// --- Trash auto-cleanup (permanent deletion of expired items) ---------------

// How often the login-driven background cleanup is allowed to run. Phase 1
// throttles via localStorage; a later phase will also persist this to an org
// SDO (check localStorage first, then the SDO) — see the trash-cleanup writeup.
export const TRASH_CLEANUP_INTERVAL_MS = 24 * 60 * 60 * 1000; // 24 hours

// localStorage key holding the epoch-ms timestamp of the last cleanup run.
export const TRASH_CLEANUP_LAST_RUN_KEY = 'redact_trash_cleanup_last_run';

// Whether opening the Trash page also purges expired items (in addition to the
// login-driven cleanup). Kept true for now; flip to false once the
// login-driven cleanup is trusted as the sole purge path. Expired items are
// always filtered out of the display regardless of this flag.
export const RUN_CLEANUP_ON_TRASH_VISIT = true;

// Upper bound of trash items scanned in a single background cleanup pass.
export const TRASH_CLEANUP_SCAN_LIMIT = 1000;
